		
<div class="col-md-2 col-sm-4">
  <ul class="nav nav-pills nav-stacked">
    <li 
      class="active"
      role="presentation">
      <a>Experiment Details</a>
    </li>
    <li *ngIf="experimentDetailsFormGroup.valid"
      class="clickable"
      role="presentation"
      (click)="saveAndContinue()">
      <a>Experiment Design</a>
    </li>
    <li *ngIf="experimentDetailsFormGroup.invalid"
      role="presentation">
      <a>Experiment Design</a>
    </li>
  </ul>
</div>
<div class="col-md-10 col-sm-8">
  <app-experiment-details-form 
    [options]="options"
    [experimentDetailsFormGroup]="experimentDetailsFormGroup"
    [requestDesign]="requestDesign"
    [currentUser]="currentUser">
  </app-experiment-details-form>
  
  <div class="pull-right">
    <button type="button" class="btn btn-default" (click)="save()" [disabled]="saving">Save</button>
    <button type="button" class="btn btn-success" (click)="saveAndContinue()" [disabled]="experimentDetailsFormGroup.invalid || saving">Save and Proceed</button>
  </div>
</div>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-details/experiment-details-form-page/experiment-details-form-page.component.html